import { Component, OnInit, Input, AfterViewChecked, ChangeDetectorRef, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MeetingsService, DropdownsService, AuthenticationService } from 'app/services';
import { merge, Subject } from 'rxjs';
import { startWith, tap, switchMap } from 'rxjs/operators';
import { forEach, includes, isString, isEmpty, clone, cloneDeep } from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { fuseAnimations } from '@fuse/animations';
import { GlobalFuntions } from 'app/_helpers';
import moment from 'moment-timezone';
import { CrmMenuService } from 'app/services/crm-menu.service';
import { GetCommercialReferencePipe } from 'app/pipes/get-commercial-reference.pipe';
import { DatePipe } from '@angular/common';

function invalidDatesValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        let startDate = clone(this.activity.get('start_date').value);
        let endDate = clone(this.activity.get('end_date').value);
        if (isString(startDate) && isString(endDate) && !isEmpty(startDate) && !isEmpty(endDate)) {
            startDate = new Date(startDate);
            endDate = new Date(endDate);
            if (startDate > endDate) {
                return { invalidDates: { value: control.value } };
            }
        }
        return null;
    };
}
@Component({
    selector: 'app-meeting-create-form',
    templateUrl: './meeting-create-form.component.html',
    styleUrls: ['./meeting-create-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    providers: [GetCommercialReferencePipe, DatePipe]
})
export class MeetingCreateFormComponent implements OnInit, AfterViewChecked {

    @Output() openTimeline: EventEmitter<any>;
    @Input() modal: boolean;
    activity: FormGroup;
    date = (moment()).format();
    public viewRecord: boolean;
    tasks: any = [];
    id: any;
    user: any;
    officeData: any;
    offices: any;
    searchOffices$ = new Subject<string>();
    filter: any;
    meetings: any;
    commercials: any;
    dossiers: any;
    clients: any;
    participant: any;
    old_end_date: any;
    nameSearch$ = new Subject<string>();
    commercialSearch$ = new Subject<string>();
    dossierSearch$ = new Subject<string>();
    clientSearch$ = new Subject<string>();
    public searching: boolean;
    public countries: any = [];
    public countrySearch: FormControl = new FormControl();
    public regions: any[];
    public regionSearch: FormControl = new FormControl();
    public cities: any = [];
    public citySearch: FormControl = new FormControl();
    public provinces: any = [];
    public provinceSearch: FormControl = new FormControl();
    participants: FormArray;
    meeting: FormArray;
    systemLang: any;
    loadingResults = false as any;
    currentAgency: any;
    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private route: ActivatedRoute,
        private _meetingsService: MeetingsService,
        private _dropdownsService: DropdownsService,
        private _translateService: TranslateService,
        private cdRef: ChangeDetectorRef,
        private _authenticationService: AuthenticationService,
        public _globalFuntions: GlobalFuntions, // for dateChange
        public _crmMenuService: CrmMenuService,
        private datePipe: DatePipe
    ) {
        _translateService.onLangChange.pipe(startWith('')).subscribe(() => {
            this.systemLang = this._translateService.currentLang === 'es' ? 'es_AR' : _translateService.currentLang;
        });
        this.openTimeline = new EventEmitter();
        this.user = this._authenticationService.currentUserValue;
        this.officeData = this._authenticationService.currentOfficeValue;
        this.filter = {};
        this.filter.options = {
            page: 1,
            limit: 1000,
            sort: {
                value: 1
            }
        };
        this.filter.query = {
            status: 'Active'
        };
    }

    ngOnInit(): void {

        this._dropdownsService.getTaskTypes(this.filter).subscribe((data: any) => {
            this.tasks = data.docs;
        });

        this._dropdownsService.getMeetingTypes().subscribe((data: any) => {
            this.meetings = data.body;
        });

        let officeRecord = false;
        // this.viewRecord = false;
        if (includes(this.router.url, 'view')) {
            this.viewRecord = true;
            officeRecord = true;
        }

        if (this._globalFuntions.getUserRole(this.user.user_role)) {
            officeRecord = true;
        }

        // tslint:disable-next-line: prefer-const
        let timeFrom = new Date();
        timeFrom.setHours(timeFrom.getHours() + 1);
        const timeTo = new Date();
        timeTo.setHours(timeTo.getHours() + 2);

        this.activity = this.formBuilder.group({

            // Ticket #1152
            // assignee: [{ value: [this.user._id], disabled: this.viewRecord }],
            subject: [{ value: '', disabled: this.viewRecord }, Validators.required],
            private: [{ value: '', disabled: this.viewRecord }],
            status: [{ value: 'Scheduled', disabled: this.viewRecord }],
            start_date: [{ value: this.date, disabled: this.viewRecord }, [invalidDatesValidator]],
            start_time: [{ value: timeFrom, disabled: this.viewRecord }],
            end_date: [{ value: this.date, disabled: this.viewRecord }, [invalidDatesValidator]],
            end_time: [{ value: timeTo, disabled: this.viewRecord }],
            repeate_type: [{ value: 'None', disabled: this.viewRecord }],
            reminder_time: [{ value: '15m', disabled: this.viewRecord }],
            task_type: [{ value: '', disabled: this.viewRecord }],
            task_type_value: this.formBuilder.group({
                en: ('')
            }),
            country: [{ value: '', disabled: this.viewRecord }],
            region: [{ value: '', disabled: this.viewRecord }],
            province: [{ value: '', disabled: this.viewRecord }],
            city: [{ value: '', disabled: this.viewRecord }],
            postal_code: [{ value: '', disabled: this.viewRecord }],
            street: [{ value: '', disabled: this.viewRecord }],
            street_number: [{ value: '', disabled: this.viewRecord }],
            google_map: [{ value: '', disabled: this.viewRecord }],
            comments: [{ value: '', disabled: this.viewRecord }],
            description: [{ value: '', disabled: this.viewRecord }],
            participants: this.formBuilder.array([this.createOpening()]),
            meeting: this.formBuilder.array([this.createMeeting()]),
            offices: [{ value: [this.officeData._id], disabled: officeRecord }, Validators.required],
            meeting_type: [{ value: '', disabled: this.viewRecord }],
            type: [{ value: '', disabled: false }],
            created_at: [{ value: '', disabled: false }],
            created_by: [{ value: '', disabled: false }],
            agency: [{ value: '', disabled: false }],
            _id: [],
            color: [{ value: '', disabled: false }]

        });
        this.participants = this.activity.get('participants') as FormArray;
        this.meeting = this.activity.get('meeting') as FormArray;
        this.currentAgency = this._authenticationService.currentAgencyValue;

        merge(this.countrySearch.valueChanges, this.activity.get('country').valueChanges)
            .pipe(
                startWith(''),
                tap(() => this.searching = true),
                switchMap(() => {
                    let search = this.activity.get('country').value;
                    if (this.countrySearch.value) {
                        search = this.countrySearch.value;
                    }
                    return this._dropdownsService.getCountries(search);
                })
            )
            .subscribe((data: any) => {
                this.searching = false;
                this.countries = data.docs;
            });

        merge(this.regionSearch.valueChanges, this.activity.get('region').valueChanges, this.activity.get('country').valueChanges)
            .pipe(
                startWith(''),
                tap(() => this.searching = true),
                switchMap(() => {
                    let search = this.activity.get('region').value;
                    if (this.regionSearch.value) {
                        search = this.regionSearch.value;
                    }
                    return this._dropdownsService.getRegions(search, this.activity.get('country').value);
                })
            )
            .subscribe((data: any) => {
                this.searching = false;
                this.regions = data.docs;
            });

        merge(this.provinceSearch.valueChanges, this.activity.get('province').valueChanges, this.activity.get('region').valueChanges)
            .pipe(
                startWith(''),
                tap(() => this.searching = true),
                switchMap(() => {
                    let search = this.activity.get('province').value;
                    if (this.provinceSearch.value) {
                        search = this.provinceSearch.value;
                    }
                    return this._dropdownsService.getProvinces(search, false, this.activity.get('region').value);
                })
            )
            .subscribe((data: any) => {
                this.searching = false;
                this.provinces = data.docs;
            });

        merge(this.citySearch.valueChanges, this.activity.get('city').valueChanges, this.activity.get('province').valueChanges)
            .pipe(
                startWith(''),
                tap(() => this.searching = true),
                switchMap(() => {
                    let search = this.activity.get('city').value;
                    if (this.citySearch.value) {
                        search = this.citySearch.value;
                    }
                    return this._dropdownsService.getCities(search, false, false, this.activity.get('province').value);
                })
            )
            .subscribe((data: any) => {
                this.searching = false;
                this.cities = data.docs;
            });


        this.searchOffices$
            .pipe(
                startWith(''),
                switchMap((search: string) => {
                    return this._dropdownsService.getOffices(search);
                }),
            )
            .subscribe((data: any) => {
                this.offices = data.body;
            });


        this.commercialSearch$
            .pipe(
                startWith(''),
                tap(() => this.searching = true),
                switchMap((search: string) => {
                    const searchFilter = {} as any;
                    if (search) {
                        const queryOr = [];
                        queryOr.push({ reference: Number(search) });
                        queryOr.push({ external_reference: { $regex: '.*' + search + '.*', $options: 'i' } });
                        queryOr.push({ other_reference: { $regex: '.*' + search + '.*', $options: 'i' } });
                        searchFilter.$or = queryOr;
                    }
                    return this._dropdownsService.getCommercialProperties(searchFilter);
                })
            )
            .subscribe((data: any) => {
                forEach(data.body, (value) => {
                    value.label = value.reference +
                        ((value?.property_type_1_data) ?
                            (' ' + value?.property_type_1_data?.value[this.systemLang]) : '');
                });
                this.searching = false;
                this.commercials = data.body;
            });
        this.dossierSearch$
            .pipe(
                startWith(''),
                tap(() => this.searching = true),
                switchMap((search: string) => {
                    return this._dropdownsService.getDossiers(search);
                })
            )
            .subscribe((data: any) => {
                this.searching = false;
                if (data.success) {
                    this.dossiers = data?.data?.map((dossier: any) => {
                        return {
                            ...dossier,
                            label: this.getDossierLabel(dossier)
                        };
                    });
                }
            });

        this.clientSearch$
            .pipe(
                startWith(''),
                tap(() => this.searching = true),
                switchMap((search: string) => {
                    const filter = { query: {} };
                    if (search) filter.query = { search };
                    return this._dropdownsService.getClients(filter);
                })
            )
            .subscribe((data: any) => {
                this.searching = false;
                if (data) {
                    for (const client of data.body) {
                        client.label = client.person_type === 'natural'
                            ? `${client.first_name || ''} ${client.last_name || ''}`.trim()
                            : client.commercial_name || '';
                    }
                    this.clients = data.body;
                }
            });

        this.nameSearch$
            .pipe(
                startWith(''),
                tap(() => this.searching = true),
                switchMap((searchValue: string) => {
                    let search = '';
                    if (searchValue) {
                        search = searchValue;
                    }
                    return this._dropdownsService.getParticipants(search);
                })
            )
            .subscribe((data: any) => {
                this.searching = false;
                this.participant = data.body;
            });

        this.id = this.route.snapshot.paramMap.get('id');
        if (this.id) {
            this._meetingsService.getById(this.id).subscribe((data: any) => {
                // to remove null values
                data = Object.entries(data).reduce((acc, [key, value]) => {
                    if (value !== null) {
                        acc[key] = value;
                    }
                    return acc;
                }, {});
                this.activity.patchValue(data);
                if (data.address && data.address.formatted_address) {
                    this.activity.get('google_map').setValue(data.address.formatted_address);
                }
                this.clearFormArray(this.participants);
                if (data.participants && data.participants.length) {
                    forEach(data.participants, (extra, key) => {
                        this.participants.push(this.createOpening());
                        this.activity.get('participants.' + key).patchValue(extra);
                    });
                } else {
                    this.participants.push(this.createOpening());
                }

                this.clearFormArray(this.meeting);
                if (data.meeting && data.meeting.length) {
                    forEach(data.meeting, (extra, key) => {
                        this.meeting.push(this.createMeeting());
                        this.activity.get('meeting.' + key).patchValue(extra);
                    });
                } else {
                    this.meeting.push(this.createMeeting());
                }
            });
        }
    }

    createOpening(): FormGroup {
        return this.formBuilder.group({
            name: [{ value: '', disabled: this.viewRecord }, Validators.required],
            email: [{ value: '', disabled: this.viewRecord }, Validators.required]
        });
    }

    createMeeting(): FormGroup {
        return this.formBuilder.group({
            related_to: [{ value: '', disabled: this.viewRecord }],
            commercial_property: [{ value: '', disabled: this.viewRecord }],
            dossier: [{ value: '', disabled: this.viewRecord }],
            client: [{ value: '', disabled: this.viewRecord }],
        });
    }

    ngAfterViewChecked(): void {
        this.cdRef.detectChanges();
    }

    clearFormArray = (formArray: FormArray) => {
        while (formArray.length !== 0) {
            formArray.removeAt(0);
        }
    }

    setEmail(event, index): void {
        if (event == undefined) {
            this.activity.get('participants.' + index + '.email').setValue('');
        } else {
            this.activity.get('participants.' + index + '.email').setValue(event.email);
        }
    }

    /**
     * Add 1 hour tot the start time and set it to the end time
     * @param startTime ${Date}
     */
    onTimeChange(startTime: Date) {
        // We are not using startTime Directly as it update the time also in start_time control
        let timeTo = cloneDeep(startTime);
        timeTo.setHours(timeTo.getHours() + 1);
        this.activity.get('end_time').setValue(timeTo);
    }

    checkEndDateFormat(dateFrom: any, dateTo: any): void {
        if (this.old_end_date != dateTo.value) {
            this.old_end_date = dateTo.value;
            this._globalFuntions.dateToChanges(dateFrom, dateTo);
        }
    }
    getDossierLabel(dossier: any): string {
        const formattedDate = this.datePipe.transform(dossier.date_contract, 'dd/MM/yyyy');
        const parts = [
            dossier.dossier_id,
            formattedDate,
            dossier.dossier_description?.trim()
        ].filter(part => part); // Removes null, undefined, and empty strings

        return parts.join(' - ');
    }

}
